import { AppDataContext } from "pages/app";
import { useContext, useEffect, useState } from "react";
import { User } from "./user";

export class Company{
  constructor(data) {
    if(data){
      Object.keys(data).forEach((name)=>{
        let value = data[name];
        this[name] = value
      })

      if(!this.company_name){
        this.company_name = this.alias ?? this.name;
      }
    }
  }

  isElite(){
    return this.is_premium === 1;
  }

  isElitePass() {
    return this.is_premium === 4
  }

  isScanSourceSelect() {
    return this.is_premium === 5
  }

  isScancash(){
    return this.is_premium === 3;
  }

  isMasterAgent(){
    return this.is_masteragent === 1;
  }

  getYearData(year_id){
    const ls = this.fiscal_year.filter(fy => fy.id == year_id)
    let is_premium = 0;
    let is_masteragent = 0;
    if(ls.length > 0){
      let data = ls[0];
      is_premium = data.pivot.is_premium;
      is_masteragent = data.pivot.is_masteragent;
    }
    return {
      is_premium,
      is_masteragent,
      isElite:()=>{
        return is_premium === 1;
      },
      isElitePass:()=>{
        return is_premium === 4
      },
      isScanSourceSelect:()=>{
        return is_premium === 5
      },
      isScancash:()=>{
        return is_premium === 3;
      },
      isMasterAgent:()=>{
        return is_masteragent === 1;
      }
    }
  }
}

export default function (){
  const data = useContext(AppDataContext)
  const [ company, setCompany ] = useState(()=>{
    if(data.company){
      return new Company(data.company);
    }
  })
  useEffect(() => {
    if(data.company){
      setCompany(new Company(data.company));
    } else {
      setCompany(null);
    }
  },[data.company])
  return {company:company, setCompany:data.setCompany}
}